/** @format */

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "../store/hook";
import { signOutSuccess } from "../store";

const ErrorRoute = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  console.log("Error route triggered for:", location.pathname);

  return <Navigate replace to={"/errors/error404"} />;
};

export default ErrorRoute;
